import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function ModalReferences({ show, onHide, referencias }) {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Referências dos processos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {referencias && referencias.length > 0 ? (
          <ul style={{ wordBreak: "break-all" }}>
            {referencias.map((ref, idx) => (
              <li key={idx}>{ref}</li>
            ))}
          </ul>
        ) : (
          <p>Nenhuma referência disponível.</p>
        )}
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button variant="outline-primary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
